<template>
  <div class="teaching-supply-apply-main"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="configInfo">
      <AppScrollbar style="height: 100%">
        <div class="main-cont">
          <div class="setup-info">
            <div class="check-cont">
              <el-checkbox v-model="form.checked"
                           true-label="1"
                           false-label="0">启用课程补修</el-checkbox>
            </div>
            <div class="steps-cont">
              <ul>
                <li>1、打开课程补修设置后，学生可以在系统进行补修在线操作；</li>
                <li>2、课程补修开放时间不允许超出当前学期的起止范围；</li>
              </ul>
            </div>
          </div>
          <div v-if="form.checked === '1'"
               class="config-info">
            <div class="config-form">
              <div class="title">
                <span class="theme-text">一、设置课程补修规则</span>
              </div>
              <el-form size="mini"
                       label-width="90px"
                       label-suffix="：">
                <el-form-item label="设置补修时间"
                              class="required">
                  <div class="date-range">
                    <el-date-picker v-model="form.startDate"
                                    type="date"
                                    prefix-icon="el-icon-date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="请选择开始日期"
                                    :picker-options="{disabledDate: disabledStartDate}">
                    </el-date-picker>
                    <div class="divider">至</div>
                    <el-date-picker v-model="form.endDate"
                                    type="date"
                                    prefix-icon="el-icon-date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="请选择结束日期"
                                    :picker-options="{disabledDate: disabledEndDate}">
                    </el-date-picker>
                  </div>
                  <div v-if="configInfo.current"
                       class="date-current">
                    <span class="theme-text"><i class="el-icon-warning-outline"></i></span>
                    <span>当前学期为：{{configInfo.current.name}}，学期起止时间：{{configInfo.current.startDate}}至{{configInfo.current.endDate}}</span>
                  </div>
                </el-form-item>
              </el-form>
            </div>
            <div class="config-form">
              <div class="title">
                <span class="theme-text">二、填写课程补修提示信息</span>
              </div>
              <el-form size="mini">
                <el-form-item>
                  <AmEditor v-model="form.tipWords"
                            :editor-height="260"></AmEditor>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </AppScrollbar>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>补修设置加载失败</div>
        <el-button type="text"
                   @click="loadConfigInfo">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import moment from 'moment'
import AppScrollbar from '../../../../../../elements/AppScrollbar'
import AmEditor from '../../../../../../elements/editor/AmEditor'
import Hint from '../../../../../../elements/Hint'
export default {
  name: 'TeachingSupplyApplyMain',
  components: {
    AppScrollbar,
    AmEditor,
    Hint
  },
  data () {
    return {
      loading: false,
      configInfo: null,
      form: {
        checked: '',
        startDate: '',
        endDate: '',
        tipWords: ''
      }
    }
  },
  computed: {
    getStartDate () {
      if (this.form.startDate) {
        return moment(this.form.startDate, 'YYYY-MM-DD').toDate()
      }
    },
    getEndDate () {
      if (this.form.endDate) {
        return moment(this.form.endDate, 'YYYY-MM-DD').toDate()
      }
    }
  },
  methods: {
    loadConfigInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/teaching/supply/apply/configInfo',
        method: 'post'
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.configInfo = response.data['configInfo'] || {}
              this.$emit('ready')
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    disabledStartDate (date) {
      let getEndDate = this.getEndDate
      if (getEndDate) {
        return date.getTime() > getEndDate.getTime()
      }
      return false
    },
    disabledEndDate (date) {
      let getStartDate = this.getStartDate
      if (getStartDate) {
        return date.getTime() < getStartDate.getTime()
      }
      return false
    },
    getConfigInfo () {
      return new Promise((resolve, reject) => {
        if (this.form.checked === '1') {
          if (!this.form.startDate) {
            reject(new Error('请设置补修开始日期'))
            return
          }
          if (!this.form.endDate) {
            reject(new Error('请设置补修结束日期'))
            return
          }
        }
        resolve(this.form)
      })
    }
  },
  mounted () {
    this.loadConfigInfo()
  },
  watch: {
    configInfo: function (val) {
      if (val) {
        Object.keys(this.form).forEach(key => {
          this.form[key] = val[key] || ''
        })
      }
    }
  }
}
</script>

<style lang="scss">
  .teaching-supply-apply-main {
    height: 100%;
    .main-cont {
      margin: auto;
      width: 600px;
      max-width: 100%;
      padding: 30px 15px;
      box-sizing: border-box;
      & > .setup-info {
        & > .check-cont {
          .el-checkbox {
            & > .el-checkbox__label {
              font-size: 13px;
              vertical-align: -1px;
            }
          }
        }
        & > .steps-cont {
          margin-top: 20px;
          ul {
            list-style: none;
            margin: 0;
            padding: 0;
            & > li {
              color: #606266;
              font-size: 12px;
              & + li {
                margin-top: 6px;
              }
            }
          }
        }
      }
      & > .config-info {
        margin-top: 20px;
        color: #606266;
        & > .config-form {
          border-top: 1px solid #ebeef5;
          padding-top: 20px;
          & > .title {
            font-size: 12px;
            margin-bottom: 15px;
          }
          & + .config-form {
            margin-top: 15px;
          }
        }
        .el-form {
          margin-top: 10px;
          .el-form-item {
            margin-bottom: 15px;
            &.required {
              .el-form-item__label {
                position: relative;
                &:before {
                  content: '*';
                  position: absolute;
                  left: -10px;
                  color: #f56c6c;
                }
              }
            }
            .el-form-item__label {
              color: #303133;
              font-size: 12px;
              text-align: left;
              white-space: nowrap;
            }
            .el-form-item__content {
              font-size: 12px;
              .date-range {
                display: table;
                width: 100%;
                & > .el-date-editor {
                  display: table-cell;
                  width: 50%;
                }
                & > .divider {
                  display: table-cell;
                  width: 0;
                  padding-left: 10px;
                  padding-right: 10px;
                }
              }
              .date-current {
                margin-top: 5px;
                & > span {
                  &:first-child {
                    margin-right: 4px;
                    font-size: 14px;
                    font-weight: bold;
                  }
                }
              }
            }
          }
        }
      }
      .tip-msg {
        color: #909399;
      }
    }
  }
</style>
